module.exports = __webpack_public_path__ + "static/media/icon-javascript.deccb5a1.svg";